import React from 'react';
import Image, { ImageProps } from './Image';
import { classNames } from './classNames';

export type CardImageProps = ImageProps;

const CardImage = React.forwardRef<HTMLImageElement, CardImageProps>(({
  className,
  ...props
}, ref) => (
  <Image ref={ref} className={classNames('card-img-top', className)} {...props} />
));

CardImage.displayName = 'CardImage';

export default CardImage;
